type Params = {
  fullName?: string;
  firstName?: string;
  lastName?: string;
};

export function getCandidateInitials({fullName, firstName, lastName}: Params): string {
  const resolvedName = fullName?.trim() || `${firstName ?? ''} ${lastName ?? ''}`.trim();
  const parts = resolvedName.split(/\s+/).filter(Boolean);

  if (parts.length >= 2) {
    return `${parts[0][0] ?? ''}${parts[parts.length - 1][0] ?? ''}`.toUpperCase();
  }
  if (parts.length === 1 && parts[0].length >= 2) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return (parts[0]?.[0] ?? '?').toUpperCase();
}
